<template>
  <div>
    <ul class="study-type clearfix">
      <li :class="{ active: item.id === studyTab.id }"
        v-for="(item, index) in list"
        :key="index"
        @click="changeTaba(item)"
        v-show="item.list.length > 0"
      >
        <div class="study-type-title">{{ item.title }}</div>
      </li>
    </ul>
    <div v-if="liststatus&&bank!=0">
      <Tklist :subjectList="subjectList"></Tklist>
    </div>
  </div>
</template>
<script>
import Tklist from "./tk_list.vue";
export default {
  props: {
    bank: {
      type: Number,
      default: 0
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      liststatus: false,
      studyTab: {},
      
      
    };
  },
  mounted() {
    // this.studyTabList = this.list
    // this.initQuestion();
    this.initTabData()
  },
  computed:{
	  studyTabList:function(){
		  return this.list
	  },
	  subjectList:function(){
		  return this.studyTab.list
	  }
  },
  methods: {

    initTabData() {
      if (this.studyTabList.length > 0) {
        this.studyTab = this.studyTabList[0];
      }
      if (this.studyTab.list.length > 0){
        this.subjectList = this.studyTab.list
        this.liststatus = true
      }
    },
    changeTaba(item) {
      this.studyTab = item;
      this.liststatus = false
      if(item.list.length > 0){
        this.$nextTick(function() {
          this.subjectList = item.list
          this.liststatus = true
        });
      }else{
        this.liststatus = false
      }
    },
  },
  components: {
    Tklist
  },
};
</script>
<style lang="less" scoped>
// @import "../../../assets/css/var.less";
// @import "../../../assets/css/study.less";
.study-type-title{
	font-size:16px
}
.study-type {
  display: flex;
  width: 100%;
  padding:20px 0;
  margin:0;
  justify-content: center;
  li {
    text-align: center;
    font-weight: bold;
    color: #666;
    padding: 5px 20px 5px 20px;
    margin-right: 30px;
    cursor: pointer;
    font-size: 22px;
    &::after {
      content: " ";
      display: block;
      margin: 5px auto 0 auto;
      width: 90px;
      height: 2px;
      background: #fff;
    }
    &:hover {
      color: #2595fd;
    }
    &.active {
      color: #2595fd;
      &::after {
        background: linear-gradient(#27a4ff 21.43%, #227efa 95.7%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mall/study/ExerciseStore.vue